
import { Link } from "react-router-dom";
import systalink from "../assets/images/logo.png"
import bg from "../assets/images/erreur-404.png"
import { useTranslation } from "react-i18next";


function NotFoundScreen() {
  const { t } = useTranslation();
  
  return (
    <main className="min-h-screen font-gellix flex max-sm:flex-col md:flex-col gap-20 bg-cover bg-center md:p-20 max-sm:p-10 text-white"  style={{ backgroundImage: "url('/images/bg.jpg')" }}>
      {/* Section Information */}
      <section className="flex-1 flex flex-col justify-center items-center bg-pink-30 relative bg-green-5">
        {/* Logo Systalink */}
        <div className="absolute top-0 left-0">
          <Link to="https://systalink.com" target="_blank" className="outline-none" >
            <img src={systalink} alt="Logo Systalink" className="" />
          </Link>
        </div>
        

        <div className="flex flex-col bg-red-5 items-center">
          <img src={bg} alt="Logo Systalink"/>

          <div className="bg-green-5 flex flex-col items-center">
            <h1 className="font-semibold lg:text-8xl md:text-2xl max-sm:text-4xl my-">Oops...</h1>
            <p className="lg:text-2xl md:text-xl my-8">{t("key_notfound_message")}</p>
            <Link to="/" className={`rounded-lg p-4 px-12 text-white bg-blue-600 font-bold text-sm`}>{t("key_notfound_btn")}</Link>
          </div>
        </div>
        
      </section>
    </main>
  );
}

export default NotFoundScreen;
